var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 150,
    viewBox: "0 0 154 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.5,
    cy: 75,
    rx: 58.5,
    ry: 57,
    fill: "#FD5C36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.869 75C153.869 94.8912 145.763 113.968 131.335 128.033C116.907 142.098 97.3388 150 76.9345 150C56.5302 150 36.9616 142.098 22.5336 128.033C8.10558 113.968 0 94.8912 0 75C0 55.1088 8.10558 36.0322 22.5336 21.967C36.9616 7.90176 56.5302 0 76.9345 0C97.3388 0 116.907 7.90176 131.335 21.967C145.763 36.0322 153.869 55.1088 153.869 75V75ZM81.7429 42.1875C81.7429 40.9443 81.2363 39.752 80.3346 38.8729C79.4328 37.9939 78.2098 37.5 76.9345 37.5C75.6593 37.5 74.4362 37.9939 73.5345 38.8729C72.6327 39.752 72.1261 40.9443 72.1261 42.1875V70.3125H43.2757C42.0004 70.3125 40.7774 70.8064 39.8756 71.6854C38.9739 72.5645 38.4673 73.7568 38.4673 75C38.4673 76.2432 38.9739 77.4355 39.8756 78.3146C40.7774 79.1936 42.0004 79.6875 43.2757 79.6875H72.1261V107.812C72.1261 109.056 72.6327 110.248 73.5345 111.127C74.4362 112.006 75.6593 112.5 76.9345 112.5C78.2098 112.5 79.4328 112.006 80.3346 111.127C81.2363 110.248 81.7429 109.056 81.7429 107.812V79.6875H110.593C111.869 79.6875 113.092 79.1936 113.993 78.3146C114.895 77.4355 115.402 76.2432 115.402 75C115.402 73.7568 114.895 72.5645 113.993 71.6854C113.092 70.8064 111.869 70.3125 110.593 70.3125H81.7429V42.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e5cb918169df59b6b0a86e5f7d42474b.svg";
export { ForwardRef as ReactComponent };